import type { ReactElement } from 'react';
import { Button } from '@/shared/ui';
import { ProductSearchList } from './product-search-list';

interface CopyEditAreaModalProps {
  readonly productId: string;
  readonly isPending: boolean;
  readonly errorMessage: string | null;
  readonly onPick: (product: { readonly id: string; readonly name: string }) => void;
  readonly onClose: () => void;
}

/** "다른 상품에서 복사" — 블랭크(제품 원형)가 같은 상품의 편집영역 기하를 가져온다. 사진·마스크는 이 상품 것을 쓴다. */
export const CopyEditAreaModal = ({
  productId,
  isPending,
  errorMessage,
  onPick,
  onClose,
}: CopyEditAreaModalProps): ReactElement => (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-foreground/40 p-4">
    <div
      role="dialog"
      aria-modal="true"
      aria-label="다른 상품에서 편집영역 복사"
      className="flex max-h-[85dvh] w-full max-w-md flex-col gap-3 rounded-lg border bg-background p-5"
    >
      <p className="font-medium">다른 상품에서 편집영역 복사</p>
      <p className="text-sm text-muted-foreground">
        같은 블랭크(제품 원형)를 쓰는 상품을 고르세요. 면·표면·인쇄 영역을 가져오고, 목업 사진과
        원통 마스크는 이 상품 것을 그대로 씁니다(없으면 올려야 합니다).
      </p>
      {errorMessage !== null ? (
        <p role="alert" className="text-sm text-destructive">
          {errorMessage}
        </p>
      ) : null}
      <ProductSearchList
        actionLabel="복사"
        excludeProductId={productId}
        disabled={isPending}
        onPick={onPick}
      />
      <div className="flex justify-end">
        <Button type="button" variant="outline" size="sm" onClick={onClose}>
          닫기
        </Button>
      </div>
    </div>
  </div>
);
